// extracted by mini-css-extract-plugin
module.exports = {"caseInfo":"case-info-module--case-info--2ShlK","caseTag":"case-info-module--case-tag--3hyvu"};